import React, { useState, useEffect } from "react";
import UnifiedForm from "../../molecules/PickupDropMap/PickupDropMap";

const Tabs = (props) => {
  const [activeTab, setActiveTab] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Handle tab selection based on searchData
    const searchType = props?.searchData?.["search-type"];
    const tabMap = {
      local: "tab2",
      airport: "tab1",
      out_station: "tab3",
      // self_drive: "tab4",
    };

    setActiveTab(tabMap[searchType] || "tab2");
  }, [props?.searchData]); // Re-run when searchData changes

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const tabs = [
    {
      id: "tab2",
      label: "Local",
      component: (
        <UnifiedForm
          activeTab={activeTab ?? "tab2"}
          modifySearch={props.modifySearch}
          searchData={props.searchData}
        />
      ),
    },
    {
      id: "tab1",
      label: "Airport Transfer",
      component: (
        <UnifiedForm
          activeTab={activeTab ?? "tab1"}
          modifySearch={props.modifySearch}
          searchData={props.searchData}
        />
      ),
    },
    {
      id: "tab3",
      label: "Outstation",
      component: (
        <UnifiedForm
          activeTab={activeTab ?? "tab3"}
          modifySearch={props.modifySearch}
          searchData={props.searchData}
        />
      ),
    },
    // {
    //   id: "tab4",
    //   label: "Self Drive",
    //   component: (
    //     <UnifiedForm
    //       activeTab={activeTab ?? "tab4"}
    //       modifySearch={props.modifySearch}
    //       searchData={props.searchData}
    //     />
    //   ),
    // },
  ];

  return (
    <div className="hero-section--item-container">
      {!isMobile ? (
        <>
          {/* <div className="hero-section--item-container-tabs">
            {tabs.map(({ id, label }) => (
              <button
                key={id}
                className={activeTab === id ? "active" : ""}
                onClick={() => handleTabClick(id)}
              >
                {label}
              </button>
            ))}
          </div>
          <div className="hero-section--item-container-tab-content">
            {tabs.find((tab) => tab.id === activeTab)?.component}
          </div> */}
        </>
      ) : (
        {/* <div className="accordion">
          {tabs.map(({ id, label, component }) => (
            <div className="accordion-item" key={id}>
              <div
                className="accordion-item-header"
                onClick={() => setActiveTab(id === activeTab ? null : id)}
              >
                {label}
              </div>
              <div
                className={`accordion-item-content ${
                  activeTab === id ? "active" : ""
                }`}
              >
                {activeTab === id && component}
              </div>
            </div>
          ))}
        </div> */}
      )}
    </div>
  );
};

export default Tabs;
